var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlug({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "brilliant-card-img-left-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5552 6.9335H28.4441C20.9821 6.9335 14.933 12.9826 14.933 20.4446V27.5557C14.933 35.0177 20.9821 41.0668 28.4441 41.0668H35.5552C43.0172 41.0668 49.0663 35.0177 49.0663 27.5557V20.4446C49.0663 12.9826 43.0172 6.9335 35.5552 6.9335ZM28.4441 5.3335C20.0985 5.3335 13.333 12.099 13.333 20.4446V27.5557C13.333 35.9014 20.0985 42.6668 28.4441 42.6668H35.5552C43.9009 42.6668 50.6663 35.9014 50.6663 27.5557V20.4446C50.6663 12.099 43.9009 5.3335 35.5552 5.3335H28.4441Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "brilliant-card-img-left-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6659 16.8887C27.157 16.8887 27.5551 17.2097 27.5551 17.6069V23.2816C27.5551 23.6788 27.157 23.9998 26.6659 23.9998C26.1748 23.9998 25.7773 23.6788 25.7773 23.2816V17.6069C25.7773 17.2097 26.1748 16.8887 26.6659 16.8887Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "brilliant-card-img-left-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3329 16.8887C37.824 16.8887 38.2221 17.2097 38.2221 17.6069V23.2816C38.2221 23.6788 37.824 23.9998 37.3329 23.9998C36.8417 23.9998 36.4443 23.6788 36.4443 23.2816V17.6069C36.4443 17.2097 36.8417 16.8887 37.3329 16.8887Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "brilliant-card-img-left-fill",
    d: "M30.2227 30.2221C30.2227 29.2403 31.0186 28.4443 32.0004 28.4443C32.9823 28.4443 33.7782 29.2403 33.7782 30.2221V31.4073C33.7782 31.7346 33.5129 31.9999 33.1856 31.9999H30.8152C30.488 31.9999 30.2227 31.7346 30.2227 31.4073V30.2221Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/Plug.28632d894c90481adb809892a853f971.svg";
export { ForwardRef as ReactComponent };